<template>
    <div>
      <h2>설정</h2>
      <p>
        Tens에듀를 처음 사용할 때 설정해야할 기본 값이 필요합니다.
      </p>
      
      <section>
        <div class="p-relative section_0" id="basic_data">
            <div class="ft-b">1)    기초데이터</div>
            <div class="p-relative section_2">
                <div><img src="@/assets/aca/manual/setting/setting_basic_data.jpg" /></div>
            </div>
        
            <div class="p-relative section_1">
                -   기초데이터는 Tens에듀 설치 후 “전체 데이터 초기화”버튼으로 한번만 실행합니다.
            </div>
            
            <div class="p-relative section_1">
                -   기본적으로 기초데이터의 내용을 변경할 수 있지만 추천하지 않습니다. 이 경우는 꼭 Tens에듀에 문의해주세요.
            </div>
            
            <div class="p-relative section_1">
                -   “할인종류”는 각 학원의 상황에 맞게 추가/삭제/변경할 수 있습니다.
            </div>
            <div class="p-relative section_2">
                <div><img src="@/assets/aca/manual/setting/setting_discount.jpg" /></div>
            </div>
            
            
        </div>


        <p></p>
        <div class="p-relative section_0" id="center_info">
            <div class="ft-b">2)  학원정보</div>
        
            <div class="p-relative section_1">
                -   학원정보에는 Tens에듀 프로그램에서 필요한 기본정보를 입력합니다.
            </div>
            <div class="p-relative section_2">
                <div><img src="@/assets/aca/manual/setting/setting_center_info.jpg" /></div>
            </div>
        </div>

        <p></p>
        <div class="p-relative section_0" id="billing_date">
            <div class="ft-b">3)  결제정보</div>
            <div class="p-relative section_1">
                -   결제정보에는 수강료 자동발생에 필요한 값을 입력합니다.
            </div>
            <div class="p-relative section_2">
                일반적으로 수강료 자동발생일은 25일, 청구일(=납입기한)은 매월의 1일로 설정합니다
            </div>
            <div class="p-relative section_2">
                <div><img src="@/assets/aca/manual/setting/setting_billing_date.jpg" /></div>
            </div>
        </div>

        <p></p>
        <div class="p-relative section_0" id="api_info">
            <div class="ft-b">4)  API정보</div>
            <div class="p-relative section_1">
                -   API정보에는 단말기, 문자메시지 설정과 같이 외부 시스템과 연동에 필요한 정보를 설정합니다.
            </div>
            <div class="p-relative section_2">
                <div><img src="@/assets/aca/manual/setting/setting_api_info.jpg" /></div>
            </div>
            <div class="p-relative section_2">
                문자메시지를 설정하는 방법은 2가지입니다. 알리고서비스를 이용하는 방법과 내폰의 문자메시지 이용료를 이용하는 방법입니다.<br/>
                알리고서비스를 이용하면, 관리가 편리한 점이 있지만 비용이 발생합니다.<br/>
                내폰을 이용하는 방법은 내폰에 있는 무료문자메시지 용량이 있기 때문에 비용이 절감됩니다. 다만 사용법이 좀더 복잡합니다. 내폰에서 이용하는 방법은 별도의 항목으로 설명합니다.<br/>
            </div>
            <div class="p-relative section_1">
                -   학생의 등하원은 선생님이 메시지를 보내는 방법과 학생앱에서 메시지를 보내는 방법이 있습니다.
            </div>
        </div>

        <p></p>
        <div class="p-relative section_0" id="notice">
            <div class="ft-b">5)  공지정보</div>
            <div class="p-relative section_1">
                -   공지정보는 학원의 기본정보를 빠르게 찾을 수 있도록 홈화면에서 “학원정보”버튼 클릭시 나타나는 내용입니다.
            </div>
            <div class="p-relative section_2">
                <div><img src="@/assets/aca/manual/setting/setting_notice_input.jpg" /></div>
            </div>
            <div class="p-relative section_2">
                와 같이 입력하였다면
            </div>
            <div class="p-relative section_2">
                <span><img src="@/assets/aca/manual/setting/setting_notice_button.jpg" /></span>  에서와 같이 홈화면의 “학원정보”버튼을 클릭하면
            </div>
            <div class="p-relative section_2">
                <div><img src="@/assets/aca/manual/setting/setting_notice_modal.jpg" /></div>
            </div>
            <div class="p-relative section_2">
                학원공지정보가 나타납니다.<br/>
                학원의 기본정보를 모든 선생님과 공유할 수 있습니다.<br/>
                예를들어 공지정보에는 학원의 블로그, 까페, 플레이스와 같은 url을 기록할 수 있습니다.
            </div>
        </div>
        
      </section>

      <q-drawer show-if-above side="right" class="bg-white">
          <q-list>
            <q-item-label header style="padding:40px 42px 20px;">바로가기</q-item-label>
            <li class="q-px-lg pointer" 
                      v-for="m in menuItems" 
                      :key="m.label"
                      @click="goTo(m.link)" >
                {{m.label}}
            </li>
            
          </q-list>
      </q-drawer>
    </div>
</template>

<script>
import goto from "./goto.js";
export default {
    components : {
    },
    data : function() {
        return {
            menuItems: [
                { label: '기초데이터', link: '#basic_data' },
                { label: '학원정보', link: '#center_info' },
                { label: '결제정보', link: '#billing_date' },
                { label: 'API정보', link: '#api_info' },
                { label: '공지사항', link: '#notice' },
            ]
        }
    },
    computed :{
    },
    methods : {
        goTo(link) {
            goto.goto_link(link);
        }
    },
    beforeMount() {
        goto.clear();
    }
}
</script>


